import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/echo",
    name: "Echo",
    component: () => import(/* webpackChunkName: "echo" */ "../views/Echo.vue"),
  },
  {
    path: "/traceroute",
    name: "Traceroute",
    component: () =>
      import(/* webpackChunkName: "traceroute" */ "../views/Traceroute.vue"),
  },
  {
    path: "/whois",
    name: "WHOIS",
    component: () =>
      import(/* webpackChunkName: "whois" */ "../views/WHOIS.vue"),
  },
  {
    path: "/dns",
    name: "DNS",
    component: () => import(/* webpackChunkName: "dns" */ "../views/DNS.vue"),
  },
  {
    path: "/reverse_dns",
    name: "Reverse DNS",
    component: () =>
      import(/* webpackChunkName: "reverse_dns" */ "../views/ReverseDNS.vue"),
  },
  {
    path: "/bgp",
    name: "BGP Routes",
    component: () =>
      import(/* webpackChunkName: "bgp" */ "../views/BGPRoutes.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
